import { IGeoJSON, IFeature } from "../types";
import _ from 'lodash';
import L from 'leaflet';

export function autoFocus(map: L.Map, geoJSON: IGeoJSON, checkHasData: (feature: IFeature) => boolean) {
  const featuresWithData: IFeature[] = geoJSON.features.filter(checkHasData);
  const centers = featuresWithData.map(feature => {
    const geometry = feature?.geometry;
    if (geometry) {
      const coords = (geometry.type === "MultiPolygon" ? _.maxBy(geometry.coordinates as any, (e: any) => e.flat().length) : geometry.coordinates).flat();
      const c1 = _.mean(coords.map(e => e[1]));
      const c2 = _.mean(coords.map(e => e[0]));
      return [c1, c2];
    }
    return [];
  });
  if (centers.length) {
    map.fitBounds(centers as [number, number][]);
  }
}